const social_media_data = [
  {
    index: 1,
    icon_class: ' fa-brands fa-facebook-square',
    where_to_go_link: 'https://www.facebook.com/prasad.sontakke.3705',
  },
  {
    index: 2,
    icon_class: 'fa-brands fa-github',
    where_to_go_link: 'https://github.com/prasadsontakke77',
  },
  {
    index: 3,
    icon_class: 'fa-brands fa-instagram',
    where_to_go_link: 'https://www.instagram.com/prasadsontakke45/',
  },
  {
    index: 4,
    icon_class: 'fa-brands fa-linkedin',
    where_to_go_link: 'https://www.linkedin.com/in/prasad-sontakke-676814205/',
  },
  {
    index: 5,
    icon_class: 'fa-brands fa-twitter',
    where_to_go_link: 'https://twitter.com/prasadsontakk19',
  },
];

export default social_media_data;
